function initializeRoomTabs(scope = document) {
  const sections = scope.querySelectorAll(".rooms");

  sections.forEach((section) => {
    if (section.dataset.roomTabsReady === "true") return;

    const tabs = section.querySelectorAll("[data-room-tab]");
    const sources = section.querySelectorAll("[data-room-source]");
    if (!tabs.length || !sources.length) return;

    const sourceMap = new Map();
    sources.forEach((source) => {
      sourceMap.set(source.dataset.roomSource, source.dataset);
    });

    const title = section.querySelector("[data-room-title]");
    const kicker = section.querySelector("[data-room-kicker]");
    const body = section.querySelector("[data-room-body]");
    const specOneLabel = section.querySelector("[data-room-spec-one-label]");
    const specOneValue = section.querySelector("[data-room-spec-one-value]");
    const specTwoLabel = section.querySelector("[data-room-spec-two-label]");
    const specTwoValue = section.querySelector("[data-room-spec-two-value]");
    const specThreeLabel = section.querySelector("[data-room-spec-three-label]");
    const specThreeValue = section.querySelector("[data-room-spec-three-value]");

    function applyRoom(targetId) {
      const data = sourceMap.get(targetId);
      if (!data) return;
      kicker.textContent = data.kicker;
      title.textContent = data.title;
      body.textContent = data.body;
      specOneLabel.textContent = data.specOneLabel;
      specOneValue.textContent = data.specOneValue;
      specTwoLabel.textContent = data.specTwoLabel;
      specTwoValue.textContent = data.specTwoValue;
      specThreeLabel.textContent = data.specThreeLabel;
      specThreeValue.textContent = data.specThreeValue;
    }

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        tabs.forEach((item) => item.classList.remove("is-active"));
        tab.classList.add("is-active");
        applyRoom(tab.dataset.roomTarget);
      });
    });

    section.dataset.roomTabsReady = "true";
  });
}

document.addEventListener("DOMContentLoaded", () => initializeRoomTabs());
document.addEventListener("shopify:section:load", (event) => initializeRoomTabs(event.target));

function initializeCollectionSort(scope = document) {
  const selectors = scope.querySelectorAll("[data-collection-sort]");

  selectors.forEach((selector) => {
    if (selector.dataset.sortReady === "true") return;

    selector.addEventListener("change", (event) => {
      const url = new URL(window.location.href);
      url.searchParams.set("sort_by", event.target.value);
      window.location.href = url.toString();
    });

    selector.dataset.sortReady = "true";
  });
}

function initializeProductGalleries(scope = document) {
  const galleries = scope.querySelectorAll("[data-product-gallery]");

  galleries.forEach((gallery) => {
    if (gallery.dataset.galleryReady === "true") return;
    const mainImage = gallery.querySelector(".product-gallery__image");
    const thumbnails = gallery.querySelectorAll("[data-gallery-thumb]");
    if (!mainImage || !thumbnails.length) return;

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener("click", () => {
        mainImage.removeAttribute("srcset");
        mainImage.removeAttribute("sizes");
        mainImage.src = thumbnail.dataset.gallerySrc;
        mainImage.alt = thumbnail.dataset.galleryAlt;
        thumbnails.forEach((item) => item.classList.remove("is-active"));
        thumbnail.classList.add("is-active");
      });
    });

    gallery.dataset.galleryReady = "true";
  });
}

function initializeRecommendationSections(scope = document) {
  const sections = scope.querySelectorAll(".product-recommendations[data-url]");

  sections.forEach((section) => {
    if (section.dataset.loaded === "true") return;

    fetch(section.dataset.url)
      .then((response) => response.text())
      .then((html) => {
        const markup = new DOMParser().parseFromString(html, "text/html");
        const renderedSection = markup.querySelector(".product-recommendations");
        if (renderedSection) {
          section.innerHTML = renderedSection.innerHTML;
          section.removeAttribute("data-url");
          section.dataset.loaded = "true";
        }
      })
      .catch(() => {});
  });
}

function initializeProductForms(scope = document) {
  const forms = scope.querySelectorAll("[data-product-form]");

  forms.forEach((form) => {
    if (form.dataset.variantReady === "true") return;

    const variantScript = form.querySelector("[data-variant-json]");
    const idInput = form.querySelector('input[name="id"]');
    const submitButton = form.querySelector('button[name="add"]');
    const optionInputs = form.querySelectorAll("[data-option-position]");
    const productSurface = form.closest(".pdp-sample");
    const addLabel = submitButton?.dataset.labelAdd || "Add to cart";
    const soldOutLabel = submitButton?.dataset.labelSoldOut || "Sold out";

    if (!variantScript || !idInput || !optionInputs.length) {
      form.dataset.variantReady = "true";
      return;
    }

    let variants = [];
    try {
      variants = JSON.parse(variantScript.textContent);
    } catch {
      form.dataset.variantReady = "true";
      return;
    }

    function updateVariant() {
      const selectedOptions = Array.from(optionInputs).map((input) => input.value);
      const matchedVariant = variants.find((variant) =>
        variant.options.every((optionValue, index) => optionValue === selectedOptions[index])
      );

      if (!matchedVariant) {
        submitButton.disabled = true;
        submitButton.textContent = soldOutLabel;
        return;
      }

      idInput.value = matchedVariant.id;
      submitButton.disabled = !matchedVariant.available;
      submitButton.textContent = matchedVariant.available ? addLabel : soldOutLabel;

      const detail = form.querySelector(`[data-variant-detail][data-variant-id="${matchedVariant.id}"]`);
      const price = productSurface?.querySelector("[data-product-price] .price__current");
      const availability = productSurface?.querySelector("[data-product-availability]");
      const selectedVariant = productSurface?.querySelector("[data-selected-variant]");
      const skuLabels = productSurface?.querySelectorAll("[data-product-sku]") || [];
      const mainImage = productSurface?.querySelector(".pdp-sample__main-image");

      if (detail && price) price.textContent = detail.dataset.price;
      if (detail && selectedVariant) selectedVariant.textContent = detail.dataset.title;
      skuLabels.forEach((label) => {
        label.textContent = detail?.dataset.sku || "Not listed";
      });

      if (availability) {
        availability.textContent = matchedVariant.available ? "Available" : "Unavailable";
        availability.classList.toggle("pdp-sample__availability--unavailable", !matchedVariant.available);
      }

      if (detail?.dataset.image && mainImage) {
        mainImage.removeAttribute("srcset");
        mainImage.removeAttribute("sizes");
        mainImage.src = detail.dataset.image;
      }

      const url = new URL(window.location.href);
      url.searchParams.set("variant", matchedVariant.id);
      window.history.replaceState({}, "", url.toString());
    }

    optionInputs.forEach((input) => {
      input.addEventListener("change", updateVariant);
    });

    updateVariant();
    form.dataset.variantReady = "true";
  });
}

function initializeAccordions(scope = document) {
  const groups = scope.querySelectorAll("[data-accordion-group]");

  groups.forEach((group) => {
    if (group.dataset.accordionReady === "true") return;

    const triggers = group.querySelectorAll("[data-accordion-trigger]");

    triggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        const item = trigger.closest(".accordion-item");
        const panel = item?.querySelector("[data-accordion-panel]");
        const isOpen = trigger.getAttribute("aria-expanded") === "true";

        triggers.forEach((otherTrigger) => {
          const otherItem = otherTrigger.closest(".accordion-item");
          const otherPanel = otherItem?.querySelector("[data-accordion-panel]");
          otherTrigger.setAttribute("aria-expanded", "false");
          if (otherPanel) {
            otherPanel.hidden = true;
            otherPanel.classList.remove("is-open");
          }
          const otherIcon = otherTrigger.querySelector(".accordion-icon");
          if (otherIcon) otherIcon.textContent = "+";
        });

        if (!isOpen && panel) {
          trigger.setAttribute("aria-expanded", "true");
          panel.hidden = false;
          panel.classList.add("is-open");
          const icon = trigger.querySelector(".accordion-icon");
          if (icon) icon.textContent = "−";
        }
      });
    });

    group.dataset.accordionReady = "true";
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initializeCollectionSort();
  initializeProductGalleries();
  initializeRecommendationSections();
  initializeProductForms();
  initializeAccordions();
});

document.addEventListener("shopify:section:load", (event) => {
  initializeCollectionSort(event.target);
  initializeProductGalleries(event.target);
  initializeRecommendationSections(event.target);
  initializeProductForms(event.target);
  initializeAccordions(event.target);
});
